<div class="hero" *ngIf="isFull && !isCertify" [innerHTML]="shared.res['#WelcomeHtml']"></div>
<div class="hero" *ngIf="!isFull && !isCertify" [innerHTML]="shared.res['#WelcomeLimitedHtml']"></div>
<div class="hero" *ngIf="isCertify" [innerHTML]="shared.res['#WelcomeCertifyHtml']"></div>

<div class="dashboard">

  <div class="dashboard-group">
    <h3 class="dashboard-group-title">{{shared.res['#Packagings']}}</h3>
    <div class="dashboard-items">
      <a class="dashboard-item" [routerLink]="['packaging']">
        <i class="dashboard-item-icon pi pi-th-large"></i>
        <span class="dashboard-item-title">{{shared.res['#Show packagings']}}</span>
      </a>
      <a class="dashboard-item" [routerLink]="['packaging', 'add']">
        <i class="dashboard-item-icon pi pi-plus"></i>
        <span class="dashboard-item-title">{{shared.res['#Add packaging']}}</span>
      </a>
    </div>
  </div>

  <div *ngIf="isConsultant" class="dashboard-group">
    <h3 class="dashboard-group-title">{{shared.res['#Projects']}}</h3>
    <div class="dashboard-items">
      <a class="dashboard-item" [routerLink]="['project']">
        <i class="dashboard-item-icon pi pi-th-large"></i>
        <span class="dashboard-item-title">{{shared.res['#Show projects']}}</span>
      </a>
      <a class="dashboard-item" [routerLink]="['project', 'add']">
        <i class="dashboard-item-icon pi pi-plus"></i>
        <span class="dashboard-item-title">{{shared.res['#Add project']}}</span>
      </a>
    </div>
  </div>

  <div *ngIf="isConsultant" class="dashboard-group">
    <h3 class="dashboard-group-title">{{shared.res.dashboard.groups.consulting.title}}</h3>
    <div class="dashboard-items">
      <a class="dashboard-item" [routerLink]="['consultant', 'customers']">{{shared.res['#Customers']}}</a>
      <a class="dashboard-item" [routerLink]="['consultant', 'proposals']">{{shared.res.dashboard.links.proposals.title}}</a>
    </div>
  </div>

  <div *ngIf="isAdmin" class="dashboard-group">
    <h3 class="dashboard-group-title">{{shared.res['#Administration']}}</h3>
    <div class="dashboard-items">
      <a class="dashboard-item" [routerLink]="['admin', 'translations']">{{shared.res.dashboard.links.translations.title}}</a>
    </div>
  </div>

  <div class="dashboard-group">
    <h3 class="dashboard-group-title">{{shared.res['#Account']}}</h3>
    <div class="dashboard-items">

      <a class="dashboard-item" [routerLink]="['password']">
        <i class="dashboard-item-icon pi pi-key"></i>
        <span>{{shared.res['#Change password']}}</span>
      </a>
    </div>
  </div>

</div>
